import { Hero } from "@/components/home/Hero";
import { Intro } from "@/components/home/Intro";
import { About } from "@/components/home/About";
import { Methode } from "@/components/home/Methode";
import { Realisations } from "@/components/home/Realisations";
import { Solar } from "@/components/home/Solar";
import { CtaBand } from "@/components/home/CtaBand";

export default function Home() {
    return (
        <main data-testid="home-page">
            <Hero />
            <Intro />
            <About />
            <Methode />
            <Realisations />
            <Solar />
            <CtaBand />
        </main>
    );
}
